import { render } from "./BankForm.vue?vue&type=template&id=2ef68a58"
import script from "./BankForm.vue?vue&type=script&lang=js"
export * from "./BankForm.vue?vue&type=script&lang=js"

import "./BankForm.vue?vue&type=style&index=0&id=2ef68a58&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__